export enum StatusEnum {
  RUNNING = 'running',
  SUCCEED = 'success',
  FAILED = 'failed',
  SCHEDULED = 'scheduled',
}
